import { Box, CircularProgress } from '@mui/material';
import { useRecordContext } from 'react-admin';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import campaignPlaceholder from '@/assets/images/ads-campaign-placeholder.jpg';
import { useCampaignTileImage } from '@/composables/useCampaignTileImage.js';
import { Palette } from '@/themes/themeOverrides/Palette';

export const CampaignTileImage = ({ sx, opacity = 1, record: recordProp }) => {
    const record = useRecordContext(recordProp);
    const { imageUrl, isLoading, hasError } = useCampaignTileImage(record?.id, record?.updatedAt);
    const [isImageLoaded, setIsImageLoaded] = useState(false);

    const src = hasError || !imageUrl ? campaignPlaceholder : imageUrl;
    const showLoader = isLoading || !isImageLoaded;

    useEffect(() => {
        setIsImageLoaded(false);
    }, [src, isLoading]);

    const containerSx = {
        position: 'relative',
        overflow: 'hidden',
        backgroundColor: Palette.gray.gray100,
        ...sx,
    };

    const imageSx = {
        display: 'block',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        opacity: isImageLoaded ? opacity : 0,
        transition: 'opacity 0.2s ease',
    };

    return (
        <Box sx={containerSx}>
            {showLoader && (
                <Box
                    sx={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <CircularProgress size={28} />
                </Box>
            )}
            {!isLoading && (
                <Box
                    component='img'
                    src={src}
                    alt={record?.name || ''}
                    onLoad={() => setIsImageLoaded(true)}
                    onError={() => setIsImageLoaded(true)}
                    sx={imageSx}
                />
            )}
        </Box>
    );
};

CampaignTileImage.propTypes = {
    sx: PropTypes.object,
    opacity: PropTypes.number,
    record: PropTypes.object,
};
